export const checkIsSameAddress = (registartionAddress, residenceAddress) => {
  if (!residenceAddress) {
    return false
  }
  return !Object.keys(residenceAddress).find(
    (key: string) => registartionAddress[key] !== residenceAddress[key]
  )
}
